import Parameter from "../../../common/components/Parameter";
import { useSelector } from "react-redux";
import { getSystemLayout } from "../../common/components/ConfigurationSummarySubstep";
import { useTranslation } from "react-i18next";

export const LinearSummaryParams = () => {
  const { t } = useTranslation();
  const systemLayout = useSelector(getSystemLayout);
  const tileSelectedInFirstStep = systemLayout.selectedTile;

  const numberOfGuidweways = Number(systemLayout.tiles[tileSelectedInFirstStep!].cstics.VSANZ_066);
  const numberOfCarriages = Number(systemLayout.tiles[tileSelectedInFirstStep!].cstics.V_S1_AE_066);

  return (
    <>
      <Parameter
        label={t("cartPage.systemLayout.label")}
        value={
          t("linearConfigSummary.guideway.info", {
            count: numberOfGuidweways,
          }) + ","
        }
      />
      <div className="mt-0">
        {t("linearConfigSummary.carriages.info", {
          count: numberOfCarriages,
        })}
      </div>
    </>
  );
};
